import FieldDictionary from '@/classes/clientOnly/permissionTreeResources/dictionaries/fieldDictionary';
import {MailboxSyncFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/MailboxSyncFields';

export const mailboxSyncFieldsDictionary: FieldDictionary<MailboxSyncFields> = [
    {text: 'API-Konfiguration', value: MailboxSyncFields.API_CONFIG},
    {text: 'Postfach', value: MailboxSyncFields.USERNAME},
    {text: 'Ordner', value: MailboxSyncFields.BOXES},
    {text: 'Aktiv', value: MailboxSyncFields.ACTIVE},
    {text: 'Fehlende Ordner', value: MailboxSyncFields.MISSING_BOXES, readOnly: true},
    {text: 'Letzter Abgleich', value: MailboxSyncFields.LAST_SYNCED_AT, readOnly: true},
    {text: 'Erzeugungsdatum', value: MailboxSyncFields.CREATED_AT, readOnly: true},
    {text: 'Änderungsdatum', value: MailboxSyncFields.UPDATED_AT, readOnly: true},
];
